export enum EmailNotificationSettingEnum {
  none = 'none',
  cancellation = 'cancellation',
  initial = 'initial',
  note = 'note',
  booking = 'booking',
}
